import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IAccountDocument } from '@epicuro-next/data/documents';
import { APP_TOP_LEVEL_PATH } from '@epicuro-next/navigation/constants';
import { select, Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';

import { selectUnsignedUserTerms } from '../store/user-state.selectors';

@Injectable()
export class UserTermsGuard {
  constructor(private store: Store, private router: Router) {}

  public canActivate() {
    return this.store.pipe(
      select(selectUnsignedUserTerms),
      filter(Array.isArray), // wait to load documents
      take(1),
      map((documents: ReadonlyArray<IAccountDocument>) => {
        if (documents?.length === 0) return true;
        return this.router.parseUrl(`/${APP_TOP_LEVEL_PATH.userTerms.path}`);
      }),
    );
  }
}
